import ym from './ym'

/* eslint-disable no-inner-declarations */
let appInfo = Object.create(null)

/**
 * 转化为int类型
 * 如果不是无法转换为有效的int类型，则返回空字符串
 */
function parseToInt(num) {
  if (!num) return ''
  num = parseInt(num, 10)
  return isNaN(num) ? '' : num
}

const platform = (() => {
  if (typeof window === 'undefined') {
    return {}
  }

  const u = navigator.userAgent
  return {
    iOS: /ipad|iphone|mac/i.test(u),
    Android: /android/i.test(u),
    Weixin: /micromessenger/i.test(u)
  }
})()

/**
 * 解析url param
 */
function getQueryStringArgs() {
  if (typeof window === 'undefined') {
    return {}
  }

  const qs = location.search.length > 0 ? location.search.substring(1) : ''
  const args = {}
  const items = qs.length ? qs.split('&') : []
  let item = null
  let name = null
  let value = null
  let i = 0
  const len = items.length
  const regx = new RegExp('(.*)=([^$].*)$', 'i')

  for (i = 0; i < len; i++) {
    item = items[i].match(regx)
    if (!item) {
      continue
    }
    // decodeURIComponent解码
    name = decodeURIComponent(item[1])
    // 移除某些版本的意外字符（换行符）
    const s = item[2].replace(/%0A/g, '')
    value = decodeURIComponent(s)
    if (name.length && !args[name]) {
      args[name] = value
    }
  }

  return args
}

const refreshAppInfoCallbacks = []

/**
 * 调用客户端的goods.getClientInfo方法，获取用户基础的信息
 * @param callback {Function} 用户信息刷新后的回调
 */
function getClientInfo(callback = () => {}) {
  if (typeof window === 'undefined') {
    return
  }

  refreshAppInfoCallbacks.push(callback)

  if (refreshAppInfoCallbacks.length > 1) {
    return
  }

  const callbackMiddleware = result => {
    refreshAppInfoCallbacks.forEach(callback => callback(result))
    refreshAppInfoCallbacks.length = 0
  }

  window.WEB_CALLBACK_APPINFO = json => {
    let result = json
    if (typeof json === 'string') {
      result = JSON.parse(json)
    }

    updateAppInfo(result)

    callbackMiddleware(result)
  }

  let result

  const loadAppinfo = () => {
    if (window.goods.getAppInfo || window.goods.getClientInfo) {
      try {
        if (window.goods.getClientInfo) {
          window.goods.getClientInfo('WEB_CALLBACK_APPINFO')
        } else {
          result = window.goods.getAppInfo(
            JSON.stringify({
              callback: 'WEB_CALLBACK_APPINFO'
            })
          )
        }
      } catch (err) {
        result = window.goods.getAppInfo()
      }
      if (result) {
        result = typeof result === 'string' ? JSON.parse(result) : result
        updateAppInfo(result)
        callbackMiddleware(result)
      }
    }
  }

  if (window.goods) {
    loadAppinfo()
  } else {
    callbackMiddleware(result)
  }
}

/**
 * 更新app信息
 *
 * @param {object} target
 *
 * @memberOf appInfo
 */
function updateAppInfo(target) {
  const app = {}

  for (const key in target) {
    if (Object.hasOwnProperty.call(target, key)) {
      const element = target[key]
      if (element !== null && element !== '') {
        // 键值全部转换为小写，防止部分参数小写部分大写的异常情况
        app[key.toLowerCase()] = target[key]
      }
    }
  }

  appInfo = { ...appInfo, ...app }
}

function getParam(name) {
  // 键值全部转换为小写，防止部分参数小写部分大写的异常情况
  const result = appInfo[name.toLocaleLowerCase()]
  return result !== undefined ? result : ''
}

// 初始化参数
updateAppInfo(getQueryStringArgs())

export default {
  /**
   * 是否为手机号实名登陆
   *
   * @memberOf appInfo
   */
  get isPhone() {
    const loginType = parseInt(getParam('loginType'), 10)
    const isPhoneNum = getParam('isPhoneNum')

    return loginType === 2 && (isPhoneNum || isPhoneNum === '')
  },
  /**
   * 是否为实名登录
   */
  get isLogin() {
    const loginType = this.loginType
    return !(loginType === '' || loginType === 4)
  },
  /**
   * 是否已绑定手机号
   */
  get isBindPhone() {
    return this.loginType === 2 || getParam('hasBindPhone')
  },
  /**
   * 检查是否为手机号登录或者第三方绑定手机号，如果不是则自动跳转登录
   */
  get checkBindPhone() {
    let isBindPhone = true
    if (!this.isLogin) {
      ym.login()
      isBindPhone = false
    } else if (!this.isPhone && !getParam('hasBindPhone')) {
      ym.bindPhone()
      isBindPhone = false
    }
    return isBindPhone
  },
  /**
   * 是否为益盟号登录
   */
  get isEmLogin() {
    return this.loginType === 0
  },

  /**
   * 老版token
   */
  get webAuthToken() {
    let token = getParam('webAuthToken')

    if (!token) {
      return ''
    }

    if (platform.Android) {
      token = decodeURIComponent(token)
    }

    return token
  },

  /**
   * 新版token
   */
  get emoneyToken() {
    return getParam('emoneyToken') || getParam('token')
  },

  /**
   * 益盟股票token
   */
  get token() {
    const token = getParam('token') || getParam('emoneyToken')

    return token || ''
  },

  /**
   * 版本
   */
  get mv() {
    const currentMv = getParam('mv') || getParam('appVersion')

    return currentMv
  },

  /**
   * 比较当前版本是否大于或等于目标版本
   * @param {string} targetMv - 目标版本
   * @param {string} [currentMv] - 当前版本
   * @param {boolean} [isIncludeEqual] - 是否包含等于
   */
  compareMv(targetMv, currentMv, isIncludeEqual = true) {
    if (!targetMv) {
      console.warn('版本比对异常：请传入要比对的版本')
      return
    }

    if (typeof currentMv === 'boolean') {
      isIncludeEqual = currentMv
      currentMv = undefined
    }

    let isSupport = false
    currentMv = currentMv || this.mv

    if (targetMv === currentMv) {
      isSupport = isIncludeEqual
    } else {
      const targetMvArr = targetMv.split('.')
      const currentMvArr = currentMv.split('.')
      if (currentMvArr.length === targetMvArr.length) {
        for (let i = 0; i < currentMvArr.length; i++) {
          if (currentMvArr[i] !== targetMvArr[i]) {
            isSupport = +currentMvArr[i] > +targetMvArr[i]
            break
          }
        }
      } else {
        isSupport = currentMvArr.length > targetMvArr.length
      }
    }

    return isSupport
  },

  /**
   * 平台
   * 2  - 益盟经典版
   * 4  - 益盟股票
   * 15 - 益盟加强版
   */
  get pd() {
    return (
      parseToInt(getParam('pd') || getParam('pid') || getParam('appId')) || 4
    )
  },

  /**
   * 平台号
   * 9  - 安卓
   * 10 - 苹果
   */
  get ar() {
    let ar = getParam('ar')
    const platform = getParam('platform')

    if (!ar && platform) {
      ar = platform === 'android' ? '10' : '9'
    }

    return parseToInt(ar)
  },

  /**
   * 渠道号
   */
  get vd() {
    return parseToInt(getParam('vd') || getParam('channelId'))
  },

  /**
   * 登录类型
   * 2 - 手机号登录
   * 0 - 匿名登录
   */
  get loginType() {
    return parseToInt(getParam('loginType'))
  },

  /**
   * 是否为夜间模式
   * @returns {boolean} true-夜间模式
   */
  get isNight() {
    const css = getParam('css')
    return css === 'b' || css === 'night'
  },

  platform,
  getParam,
  updateAppInfo,
  getClientInfo
}
